import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const { CONFIG } = require("../../config");

export const omsBaseQuery = async (args, WebApi, extraOptions) => {
  const { clientId, authToken } = args;
  const version  = args?.version ? args.version : "v1";
  const baseUrl = CONFIG.LOCUS.LILY_API?.[`LILY_PROD_BASE_URL_${clientId}`];

  const omsBaseQuery = fetchBaseQuery({
    baseUrl: `${baseUrl}/${version}/client/${clientId}`,
    prepareHeaders: (headers) => {
      // headers.set("authorization", `${authToken}`);
      if (authToken) {
        headers.set("authorization", `Bearer ${authToken}`);
      }
      return headers;
    },
  });
  return omsBaseQuery(args, WebApi, extraOptions);
};

export const createOrdersApi = createApi({
  baseQuery: omsBaseQuery,
  endpoints: (builder) => ({
    createOrders: builder.mutation({
      query: ({ clientId, authToken, reqBody, version }) => {
        return {
          url: "order",
          method: "POST",
          body: reqBody,
          clientId,
          authToken,
          version
        };
      },
    }),
    createGroup: builder.mutation({
      query: ({ clientId, authToken, reqBody, id }) => {
        return {
          url: `group/${id}`,
          method: "PUT",
          body: reqBody,
          clientId,
          authToken,
        };
      },
    }),
    createTeamGroupMapping: builder.mutation({
      query: ({ clientId, authToken, reqBody }) => {
        return {
          url: "team-group-mapping",
          method: "PUT",
          body: reqBody,
          clientId,
          authToken,
        };
      },
    }),
    updateGroup: builder.mutation({
      query: ({ clientId, authToken, reqBody, id }) => {
        return {
          url: `group/${id}`,
          method: "PATCH",
          body: reqBody,
          clientId,
          authToken,
        };
      },
    }),
    updateTeamGroupMapping: builder.mutation({
      query: ({ clientId, authToken, reqBody, id }) => {
        return {
          url: `team-group-mapping/${id}`,
          method: "PATCH",
          body: reqBody,
          clientId,
          authToken,
        };
      },
    }),
    createBillingReport: builder.mutation({
      query: ({ clientId, authToken, reqBody }) => {
        return {
          url: `report/rider-billing`,
          method: "POST",
          body: reqBody,
          clientId,
          authToken,
        };
      },
    }),
    createInsightReport: builder.mutation({
      query: ({ clientId, authToken, reqBody }) => {
        return {
          url: `report/insight`,
          method: "POST",
          body: reqBody,
          clientId,
          authToken,
        };
      },
    }),
  }),
});

export const {
  useCreateOrdersMutation,
  useCreateGroupMutation,
  useCreateTeamGroupMappingMutation,
  useUpdateGroupMutation,
  useUpdateTeamGroupMappingMutation,
  useCreateBillingReportMutation,
  useCreateInsightReportMutation
} = createOrdersApi;
